/**
 * AuthLogoutListener
 * Listens for auth:logout events from the event bus and navigates to /login
 * using React Router (SPA navigation, no hard reload).
 * Must be rendered inside <Router>.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authEvents } from '../services/authEvents';
import { useAuthStore } from '../stores/authStore';

export function AuthLogoutListener() {
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = authEvents.on('auth:logout', (detail) => {
      console.log('[AuthLogoutListener] Logout event received:', detail.reason);
      useAuthStore.getState().reset();
      navigate('/login', { replace: true });
    });
    return unsubscribe;
  }, [navigate]);

  return null;
}
